import React from 'react';
import 'rc-dialog/assets/bootstrap.css';
import SelectCommon from '../Common/SelectCommonDefault'
import Buscador from '../../Buscador';


class NuevaSolicitud extends React.Component {

    constructor( props ) {
        super( props );
        this.state = {
            promotorId:this.props.data.promotorSeleccionado,
            promotorNombre:"",
            sucursalModifSeleccionada:false
        };
        this.seleccionarSucursal = this.seleccionarSucursal.bind(this)
    }

    componentWillReceiveProps(nextProps){
        if(this.props.data.promotorSeleccionado!=nextProps.tarjetas.solicitudCuenta.promotorSeleccionado){
            this.props.seleccionarPromotor(nextProps.tarjetas.solicitudCuenta.promotorSeleccionado)
            let nombre = this.props.data.ATLAS_PROMOTOR.filter((p) => p.Id == nextProps.tarjetas.solicitudCuenta.promotorSeleccionado)
            if(nombre[0]){
                this.setState({promotorId:nextProps.data.promotorSeleccionado, promotorNombre:nombre[0].Descripcion})  
            }else{
                this.setState({promotorId:nextProps.data.promotorSeleccionado, promotorNombre:""})
            }     
        }
        
        if(this.props.data.promotorSeleccionado && this.state.promotorNombre == "" && this.props.data.ATLAS_PROMOTOR.length>0){
            let nombre = this.props.data.ATLAS_PROMOTOR.filter((p) => p.Id == this.props.data.promotorSeleccionado)
            if(nombre[0]){
                this.setState({promotorId:nextProps.data.promotorSeleccionado, promotorNombre:nombre[0].Descripcion})  
            }  
        }
    }

    seleccionarSucursal(action,idSucursal){
        this.props.selectCombo("sucursalSeleccionadaId",idSucursal);
        this.props.selectSucursal(idSucursal);
    }

    render() {
        const { data, seleccionarPromotor, selectCombo, productoSelected, selectCheckBox,loadDataFromTarjetas, tarjetas } = this.props;
        const {  ATLAS_SUCURSALES, PRODUCTO, ATLAS_TIPO_CUENTA, ERROR_CUENTA, ATLAS_GRUPO_AFINIDAD, ATLAS_SEGMENTO_CARTERA,ATLAS_PROMOTOR, GET_PRODUCTO_DEFAULT_CABAL_PRODUCTO, ATLAS_MARCA_COMPARTIDA } = data;

        let modifProducto = null
        let valoresDefault = !tarjetas.esModificacion ? GET_PRODUCTO_DEFAULT_CABAL_PRODUCTO : tarjetas.datosSolicitud //SI ES UNA MODIFICACION SE REEMPLAZAN LOS DEFAULT POR LOS VALORES SELECCIONADOS EN LA SOLICITUD A MODIFICAR
       
        let showGA = false;
        let showSC = false;
        let showMC = false;

        let parametroGeneral = data.GET_ATLAS_PARAMETRO_GENERAL;

        //CONDICIONES PARA MOSTRAR O NO COMBOS SEGÚN EL PRODUCTO SELECCIONADO
        if (data && data.GET_PRODUCTO_CABAL_PRODUCTO_ID) {
            let product = data.GET_PRODUCTO_CABAL_PRODUCTO_ID
            if (product && product.AsociaGrupoAfinidad) showGA = true;
            if (product && product.AsociaSegmentoCartera && parametroGeneral.SINOSEGMENTOSCARTERA) showSC = true;
            if (product && product.AsociaMarcaCompartida && parametroGeneral.SINOMARCACOMPARTIDA) showMC = true;
        }

        let haySucursal = data.sucursalSeleccionadaId > 0

        //SI SE TRATA DE UNA MODIFICACIÓN, LO PRIMERO QUE SE DEBE CARGAR AUTOMÁTICAMENTE ES LA SUCURSAL, PARA QUE FILTRE LOS PRODUCTOS.
        //SI SE TRATA DE UNA MODIFICACIÓN, LO PRIMERO QUE SE DEBE CARGAR AUTOMÁTICAMENTE ES LA SUCURSAL, PARA QUE FILTRE LOS PRODUCTOS.
        if(tarjetas.esModificacion && !haySucursal && !tarjetas.vuelveDeAdicional && !this.state.sucursalModifSeleccionada){
            let suc = parseInt(tarjetas.datosSolicitud.sucursalSeleccionadaId)
            this.seleccionarSucursal("sucursalSeleccionadaId",suc)
            this.setState({sucursalModifSeleccionada:true})
        }
        
        //SI YA SE CARGÓ LA SUCURSAL PARA LA MODIFICACIÓN, LO SIGUIENTE ES CARGAR EL PRODUCTO, QUE A SU VEZ CARGARÁ TODOS LOS VALORES POSIBLES EN LOS COMBOS.
        if(!data.isFetching && tarjetas.esModificacion && haySucursal && PRODUCTO && data.GET_PRODUCTO_CABAL_PRODUCTO_ID && !data.GET_PRODUCTO_CABAL_PRODUCTO_ID.Id && !tarjetas.vuelveDeAdicional && !data.productoCargado){
            let prod = parseInt(tarjetas.datosSolicitud.ProductoId)
            this.props.productoSelected(prod);
            this.props.cargarDatosModificacion("productoCargado")
        }

        //UNA VEZ QUE SE CARGÓ EL PRODUCTO SE COPIAN LAS SELECCIONES DE LA SOLICITUD ORIGINAL POR SECCIÓN Y PASA A TRUE EL FLAG DE DATOS CARGADOS.
        if( !this.props.tarjetas.vuelveDeAdicional && tarjetas.esModificacion && tarjetas.datosSolicitud.PromotorId && data.GET_PRODUCTO_CABAL_PRODUCTO_ID && data.GET_PRODUCTO_CABAL_PRODUCTO_ID.Id && !data.datosGeneralesModificacion){
            //SE BUSCARÁ QUE EL CAMPO AÚN NO SE HAYA CARGADO Y EN ALGUNOS CASOS QUE CORRESPONDA SEGÚN EL PRODUCTO
            !data.promotorSeleccionado && this.props.seleccionarPromotor(tarjetas.datosSolicitud.PromotorId);

            //SI YA SE CARGARON TODOS LOS DATOS DE LA SECCIÓN PASA A TRUE EL FLAG QUE LO INDICA
            if(data.promotorSeleccionado>0) this.props.cargarDatosModificacion("datosGeneralesModificacion")
            
        }
    
        //RECUPERA LAS SELECCIONES GUARDADAS EN TARJETAS CUANDO SE AVANZÓ A LA PANTALLA ADICIONALES Y SE VOLVIÓ, YA QUE ES EL ÚNICO LUGAR DONDE PERSISTEN.
        if(tarjetas && tarjetas.vuelveDeAdicional && !data.vuelveDeAdicionalCargado){
            loadDataFromTarjetas("vuelveDeAdicionalCargado")
            this.props.volverASolicitudNSC(false)
        }

        let sucursales = ATLAS_SUCURSALES;
        if(tarjetas.esModificacion && data.sucursalSeleccionadaId){
            sucursales=sucursales.filter(suc=>suc.Id == data.sucursalSeleccionadaId)
        }

        let productos = PRODUCTO;
        if(tarjetas.esModificacion && data.GET_PRODUCTO_CABAL_PRODUCTO_ID && data.GET_PRODUCTO_CABAL_PRODUCTO_ID.Id){
            productos = productos.filter(producto=>producto.Id == data.productoId)
        }


        return (
            <div className="row">
                { <div className="datos-generales-cuenta col-md-12">
                    <div className="divisor-section bottom-separator" >
                        <h2>Datos Generales de la Cuenta </h2>
                    </div>
                    <div className="form-group bottom-separator-xs">
                        <label className="label-primary">
                            Sucursal
                                    </label>
                                    <SelectCommon esModificacion={tarjetas.solicitudCuenta.esModificacion} selecciones={data} infoData={sucursales} valorCombo={0} selectCombo={this.seleccionarSucursal} nombreAction={"sucursalSeleccionadaId"} />

                        {(!data.ERROR_CUENTA["sucursalSeleccionadaId"])
                            && <label className="error">{"Debe seleccionar una sucursal."}</label>}
                    </div>
                    <div className="form-group bottom-separator-xs">
                        <label className="label-primary">
                            Producto
                                    </label>
                        <SelectCommon haySucursal={haySucursal} isFetchingData={data.isFetching} esModificacion={tarjetas.esModificacion} selecciones={data} producto={data.GET_PRODUCTO_CABAL_PRODUCTO_ID} infoData={PRODUCTO} valorCombo={modifProducto} selectCombo={productoSelected} nombreAction={"productoId"} />

                        {(!data.ERROR_CUENTA["productoId"])
                            && <label className="error">{"Debe seleccionar un producto."}</label>}
                    </div>
                    {showGA && <div className="form-group bottom-separator-xs">
                        <label className="label-primary">
                            Grupo de Afinidad
                                    </label>
                                    <SelectCommon esModificacion={tarjetas.solicitudCuenta.esModificacion} selecciones={data} infoData={ATLAS_GRUPO_AFINIDAD} valorCombo={valoresDefault["GrupoAfinidadDefaultId"] ? valoresDefault["GrupoAfinidadDefaultId"] : valoresDefault["GrupoAfinidadId"]} selectCombo={selectCombo} nombreAction={"grupoAfinidadSeleccionadoId"} />

                        {(!data.ERROR_CUENTA["grupoAfinidadSeleccionadoId"])
                            && <label className="error">{"Debe seleccionar un grupo de afinidad."}</label>}
                    </div>}
                   {showSC && <div className="form-group bottom-separator-xs">
                        <label className="label-primary">
                            Segmento de Cartera
                                    </label>
                                    <SelectCommon esModificacion={tarjetas.solicitudCuenta.esModificacion} selecciones={data} infoData={ATLAS_SEGMENTO_CARTERA} valorCombo={valoresDefault["SegmentoCarteraDefaultId"] ? valoresDefault["SegmentoCarteraDefaultId"] : valoresDefault["SegmentoCarteraId"]} selectCombo={selectCombo} nombreAction={"segmentoCarteraSeleccionadoId"} />

                        {(!data.ERROR_CUENTA["segmentoCarteraSeleccionadoId"])
                         && <label className="error">{"Debe seleccionar un segmento de cartera."}</label>}
                    </div>}
                   {showMC && <div className="form-group bottom-separator-xs">
                        <label className="label-primary">
                            Programa de Marcas Compartidas
                                    </label>
                                    <SelectCommon esModificacion={tarjetas.solicitudCuenta.esModificacion} selecciones={data} infoData={ATLAS_MARCA_COMPARTIDA} valorCombo={valoresDefault["MarcaCompartidaDefaultId"] ? valoresDefault["MarcaCompartidaDefaultId"] : valoresDefault["MarcaCompartidaId"]} selectCombo={selectCombo} nombreAction={"marcaCompartidaSeleccionadaId"} />

                    {(!data.ERROR_CUENTA["segmentoCarteraSeleccionadoId"])
                    && <label className="error">{"Debe seleccionar un segmento de cartera."}</label>}
                    </div>}
                    <label className="label-primary">Promotor </label>
                    {this.state.promotorId>0 ? <div>
                        <div className="promotorSeleccionadoLabel">
                            {this.state.promotorNombre}
                            <button onClick={() => { seleccionarPromotor(0) }}>x</button>
                        </div>
                    </div> :
                        <Buscador promotores={ATLAS_PROMOTOR} seleccionarPromotor={seleccionarPromotor} />
                    }


                </div> }
            </div>

        )
    }
}

export default NuevaSolicitud;